/**
 * The context's state. Not persisted (a reload starts in `session` mode, as the working sale starts
 * empty), and reset on logout as a second line behind `leaveChosenMode`. Only `ordering/start`
 * dispatches its actions.
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { supportLogout, userLogout } from "../redux-store/slices/LoginSlice/actions";
import type { ChosenBranch, OrderingContext } from "./types";

const SESSION: OrderingContext = { source: "session" };

const slice = createSlice({
  name: "orderingContext",
  initialState: SESSION as OrderingContext,
  reducers: {
    chosenModeEntered: (): OrderingContext => ({ source: "chosen" }),
    branchChosen: (_state, action: PayloadAction<ChosenBranch>): OrderingContext => ({ source: "chosen", branch: action.payload }),
    sessionModeRestored: (): OrderingContext => SESSION,
  },
  extraReducers: (builder) => {
    builder.addCase(userLogout, () => SESSION).addCase(supportLogout, () => SESSION);
  },
});

export const { chosenModeEntered, branchChosen, sessionModeRestored } = slice.actions;
export const orderingContextReducer = slice.reducer;
